import { Input, ConfigProvider } from 'antd';
import { SearchOutlined } from '@ant-design/icons';

export default function SearchSection({ searchTerm, onSearchChange, onSearch }) {
    return (
        <div className="search-section" style={{ width: 786 }}>
            <ConfigProvider
                theme={{
                    components: {
                        Input: {
                            /* 这里是你的组件 token */
                            controlHeight: 60,
                            borderRadius: 14,
                            borderWidth: 4,
                            colorBorder: '#FFF',
                            hoverBorderColor: '#FFF',
                            activeBorderColor: '#FFF',
                            colorText: "#fff",
                            fontSize: 18,
                            colorBgContainer: "transparent",
                        },
                        Button: {
                            // 设置搜索按钮样式
                            controlWidth: 130,
                            colorPrimary: "#FFF2EA", // 背景色
                            colorPrimaryHover: "#FFF", // 悬停背景色
                            colorPrimaryActive: "#FFF", // 点击背景色
                            colorPrimaryBorder: "#FFF2EA", // 边框颜色
                            colorText: "#FA6400", // 文字颜色
                            colorTextLightSolid: "#FA6400", // 主按钮文字颜色
                            fontSize: 18,
                            borderRadius: 14,
                            controlHeight: 60,
                            fontWeight: 600
                        },
                    },
                }}
            >
                <Input.Search
                    allowClear
                    enterButton="Search"
                    // value={searchTerm}
                    // onChange={(e) => onSearchChange(e.target.value)}
                    // onClear={() => onSearchChange('')}
                    onSearch={onSearch}
                    style={{ height: 60, borderWidth: 4 }}
                />
            </ConfigProvider>
        </div>
    );
}